import { AggregationMethodEnum } from "./timeseries.js";
import { zAny, zArr, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const KPIsGetAllArgs = zObj({ plantId: zNum() });
export const KPIEditArgs = zObj({ dbId: zNum(), value: zAny() });
export const KPIAddArgs = zObj({ assetId: zNum(), plantId: zNum(), value: zAny() });
export const KPIDeleteArgs = zObj({ kpiId: zNum() });
export const KPIGetForAssetArgs = zObj({ assetId: zNum() });
export const KPI = zObj({
    aggregation: zArr(AggregationMethodEnum),
    combine_method: zStr(),
    display_mode: zStr(),
    display_name: zStr(),
    kpi_name: zArr(zStr()),
    related_to: zArr(zStr()),
    pre_label: zOptional(zStr()),
    header: zOptional(zStr()),
    source: zStr(),
    unit: zStr(),
    multiplier: zOptional(zNum()),
    id: zNum(),
});
export const KPIs = zArr(KPI);
//# sourceMappingURL=kpi.js.map